export const unities: { [key: string]: string; } = {
  liter: 'L',
  kilometers: 'Km',
  hours: 'H',
  item: 'un',
  gram: 'g',
  unit: 'unid',
  cubic_meter: 'm³',
}

export const unitiesDecimals: { [key: keyof typeof unities]: number; } = {
  liter: 3,
  kilometers: 2,
  hours: 2,
  item: 0,
  gram: 2,
  cubic_meter: 2,
}
